var e = {
	title: "Shift briefing",
	artifactTitle: "Shift briefing · {{property}}",
	generatedAt: "Written {{time}}",
	cached: "From earlier today",
	regenerate: "Write it again",
	open: "Open briefing",
	generating: "Writing the briefing…",
	empty: "Nothing to report",
	sections: {
		arrivals: "Arrivals",
		departures: "Departures",
		rooms: "Rooms",
		risks: "Risks",
		open_requests: "Open requests"
	},
	refusal: {
		BRIEFING_RATE_LIMITED: "Too many briefings this hour. Try again later.",
		BRIEFING_UNAVAILABLE: "The briefing could not be written right now. Try again in a moment.",
		PROPERTY_NOT_FOUND: "This property is not available to you."
	}
};
//#endregion
export { e as default };
